var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    stroke: "#5F6F7C",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_19709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8669 16.1936C12.2325 16.1936 13.3396 15.0854 13.3396 13.7184C13.3396 12.3514 12.2325 11.2432 10.8669 11.2432C9.50133 11.2432 8.39429 12.3514 8.39429 13.7184C8.39429 15.0854 9.50133 16.1936 10.8669 16.1936Z",
    fill: "#5F6F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8135 10.1736C20.7408 10.0896 20.654 10.0224 20.5506 9.97483C20.1841 9.80403 19.7142 9.94123 19.4709 10.3192C19.4653 10.3276 19.4541 10.3304 19.4457 10.3304C15.9857 9.39802 12.5257 8.46841 9.06284 7.536C8.78593 7.46319 8.48664 7.4996 8.24888 7.6564C7.98316 7.8328 7.79016 8.0904 7.72303 8.38721C7.63632 8.76521 7.751 9.18802 8.00274 9.44282C8.08106 9.52122 8.24888 9.68923 8.44188 9.64443C8.60691 9.60803 8.69362 9.43722 8.7132 9.39522C8.83907 8.92762 8.96774 8.45441 9.09641 7.984C12.5061 8.88562 15.9185 9.78723 19.3282 10.6888C19.0541 11.2853 18.78 11.8817 18.5031 12.4781C18.4891 12.4809 18.4723 12.4865 18.4555 12.4921C18.3856 12.5173 18.338 12.5509 18.3324 12.5565C18.2737 12.5985 15.1549 14.5361 10.8222 17.2297C10.7159 17.3137 10.4362 17.5629 10.3271 17.9857C10.2628 18.2406 10.2824 18.4562 10.3076 18.5878C10.9649 20.9006 11.6222 23.2106 12.2767 25.5235L7.17759 33.61C6.83914 34.1476 6.99858 34.8616 7.53562 35.2004C7.72582 35.3208 7.9384 35.3796 8.14819 35.3796C8.53139 35.3796 8.90341 35.1892 9.12438 34.842L14.4557 26.3831L14.4668 34.3492C14.4668 34.9848 14.9843 35.5 15.6193 35.5C15.6193 35.5 15.6193 35.5 15.6221 35.5C16.257 35.5 16.7745 34.982 16.7717 34.3464C16.7661 30.9583 16.7633 27.5731 16.7577 24.185C16.4248 22.5666 16.2486 21.6958 15.9157 20.0774C15.913 20.0718 15.9157 20.0634 15.9213 20.0578C16.6961 19.0638 17.4737 18.0725 18.2485 17.0813C18.2849 17.0337 18.3157 16.9833 18.3408 16.9273C19.2023 14.9673 20.0639 13.0045 20.9254 11.0444C21.0512 10.7532 21.0205 10.4088 20.8135 10.1736ZM16.9591 15.9837C16.4612 16.2329 15.9633 16.4849 15.4654 16.7341C15.4654 16.5661 15.4654 16.3953 15.4654 16.2273C16.0948 15.8409 16.7241 15.4573 17.3535 15.0709C17.222 15.3761 17.0905 15.6785 16.9591 15.9837Z",
    fill: "#5F6F7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_19709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/Coach.4ab18d14e22cddd3f69c3584211ecd5a.svg";
export { ForwardRef as ReactComponent };